import { Modal, Box, Typography, IconButton } from "@mui/material";
import { IModalRCAWithNoActionPlansByMillSettings } from "./IModalRCAWithNoActionPlansByMillSettings";
import { useStyles } from "./RCAWithNoActionPlansByMillModal.styles";
import { MainTable } from "components";
import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import { IMainTableColumn } from "components/MainTable/MainTableInterfaces";
import RCAIcon from "pages/Corporate/RCA/images/rca_icon.svg";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import { CORPORATE_BACKOFFICE_PATHS } from "constants/constants";
import { useNavigate } from "react-router-dom";
import { RCAAPComplianceEntity } from "entities/RCA/RCAAPComplianceEntity/RCAAPComplianceEntity";
import { IRCADisplayNumber } from "entities/RCA/RCAAPComplianceEntity/RCAAPComplianceEntityInterfaces";

interface IRcaNoActionPlanColumns extends Omit<IMainTableColumn, "render"> {
    render: (row: IRCADisplayNumber) => string | JSX.Element | number;
}

const RCAWithNoActionPlansByMillModal = ({ open, handleClose, data }: IModalRCAWithNoActionPlansByMillSettings) => {
    const navigate = useNavigate();
    const classes = useStyles();
    const mainClasses = useRCAMainStyles();
    const { t } = useTranslation();

    const { rcaDisplayNumbers, loading: loadingDisplayNumbers } = RCAAPComplianceEntity.GetRCADisplayNumbers(
        data?.rca_without_ap_list || [],
    );

    const tableColumns: IRcaNoActionPlanColumns[] = [
        {
            id: "rca_id",
            label: t("rca.compliance.rca_compliance.ap_per_rca.rca"),
            hideSortIcon: true,
            render: (row: IRCADisplayNumber) => (
                <div className={classes.descriptionWrapper}>
                    <img src={RCAIcon} alt="RCA icon" />
                    <span>{`${t("rca.rca")}-${row.display_number}`}</span>
                </div>
            ),
        },
    ];

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={classes.modal}
        >
            <Box className={classes.modalContent}>
                <div>
                    <Typography variant="h6" className={classes.modalTitle}>
                        {t("rca.compliance.rca_compliance.ap_per_rca.modalTitle")}
                        <IconButton onClick={() => handleClose()}>
                            <CloseIcon />
                        </IconButton>
                    </Typography>
                </div>
                <div className={classes.modalBody}>
                    <div className={classes.userNameContainer}>
                        {data?.name}
                        <span className={classes.percentageDetail}>
                            {data?.rca_without_action_plans} {t("rca.compliance.rca_compliance.ap_per_rca.rca")}
                        </span>
                    </div>
                    <div className={mainClasses.contentWrapper}>
                        <div style={{ padding: 5.5 }} className={`${mainClasses.contentCard}`}>
                            <MainTable
                                maxHeight={false}
                                customStyle={`${mainClasses.contentTable}`}
                                paperElevation={0}
                                paperCustomStyle={mainClasses.contentTablePaper}
                                columns={tableColumns as IMainTableColumn[]}
                                tableCellCustomStyle={mainClasses.contentTableCell}
                                tableExpandedRowCustomStyle={mainClasses.contentTableExpandedRow}
                                loading={loadingDisplayNumbers}
                                rows={rcaDisplayNumbers}
                                onRowClick={(row: Object) => {
                                    const rcaRow = row as IRCADisplayNumber;
                                    navigate(
                                        `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.RCA_LIBRARY.ROOT}/${rcaRow.rca_id}`,
                                        {
                                            state: {
                                                from: `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.RCA_LIBRARY.ROOT}`,
                                            },
                                        },
                                    );
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default RCAWithNoActionPlansByMillModal;
